module.exports = __webpack_public_path__ + "static/media/l_dot_15.212068ba.png";